/**
 * Конфигурация цветов для графиков и визуализаций
 */

// Основные цвета для диаграмм
export const PRIMARY_COLORS = {
    blue: {
        main: "rgba(53, 162, 235, 1)",
        light: "rgba(53, 162, 235, 0.5)",
        lighter: "rgba(53, 162, 235, 0.2)",
    },
    red: {
        main: "rgba(239, 68, 68, 1)",
        light: "rgba(239, 68, 68, 0.5)",
        lighter: "rgba(239, 68, 68, 0.2)",
    },
    green: {
        main: "rgba(16, 185, 129, 1)",
        light: "rgba(16, 185, 129, 0.5)",
        lighter: "rgba(16, 185, 129, 0.2)",
    },
    yellow: {
        main: "rgba(255, 205, 86, 1)",
        light: "rgba(255, 205, 86, 0.5)",
        lighter: "rgba(255, 205, 86, 0.2)",
    },
    purple: {
        main: "rgba(153, 102, 255, 1)",
        light: "rgba(153, 102, 255, 0.5)",
        lighter: "rgba(153, 102, 255, 0.2)",
    },
    indigo: {
        main: "rgba(87, 101, 226, 1)",
        light: "rgba(87, 101, 226, 0.5)",
        lighter: "rgba(87, 101, 226, 0.2)",
    },
    orange: {
        main: "rgba(245, 158, 11, 1)",
        light: "rgba(245, 158, 11, 0.5)",
        lighter: "rgba(245, 158, 11, 0.2)",
    },
    gray: {
        main: "rgba(209, 213, 219, 1)",
        light: "rgba(209, 213, 219, 0.5)",
        lighter: "rgba(209, 213, 219, 0.2)",
    },
};

export const CHART_COLORS = {
    delays: PRIMARY_COLORS.yellow.light,
    overtime: PRIMARY_COLORS.indigo.light,
    earlyExit: PRIMARY_COLORS.orange.light,
    attendance: PRIMARY_COLORS.purple.light,
    missed: PRIMARY_COLORS.red.light,
};

// Цвета для KPI статусов
export const STATUS_COLORS = {
    success: PRIMARY_COLORS.green.main, // green-500 // red-500
    delay: PRIMARY_COLORS.yellow.main,
    overtime: PRIMARY_COLORS.indigo.main,
    earlyExit: PRIMARY_COLORS.orange.main,
    missed: PRIMARY_COLORS.red.main,
};

// Цвета для тепловой карты посещаемости
export const HEATMAP_COLORS = {
    present: "#34d399", // green-400, присутствие
    delay: "#fbbf24", // amber-400, опоздание
    overtime: "#818cf8", // indigo-400, переработка
    earlyExit: "#fb923c", // orange-400, ранний уход
    missed: "#f87171", // red-400, пропуск
    weekend: "#d1d5db", // gray-300, выходной
};

// Градиенты для графиков
export const createGradient = (ctx, color) => {
    if (!ctx) return color.main;

    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, color.light);
    gradient.addColorStop(1, color.lighter);

    return gradient;
};

// Типовые наборы для графиков
export const CHART_DATASETS = {
    delays: {
        backgroundColor: PRIMARY_COLORS.yellow.light,
        borderColor: PRIMARY_COLORS.yellow.main,
        borderWidth: 1,
    },
    overtime: {
        backgroundColor: PRIMARY_COLORS.indigo.light,
        borderColor: PRIMARY_COLORS.indigo.main,
        borderWidth: 1,
    },
    earlyExit: {
        backgroundColor: PRIMARY_COLORS.orange.light,
        borderColor: PRIMARY_COLORS.orange.main,
        borderWidth: 1,
    },
    attendance: {
        backgroundColor: PRIMARY_COLORS.purple.light,
        borderColor: PRIMARY_COLORS.purple.main,
        borderWidth: 1,
    },
    missed: {
        backgroundColor: PRIMARY_COLORS.red.light,
        borderColor: PRIMARY_COLORS.red.main,
        borderWidth: 1,
    },
};
